import axios from "axios";

const baseUrl = process.env.REACT_APP_NOT_SECRET_CODE + "/call-workspace";

const headers = (token, contentType) => ({
  "Content-Type": contentType || "application/json",
  "X-Request-ID": "124",
  "X-Country-Code": "BD",
  "X-Client-Name": "WEBSITE",
  "X-Client-Version": "123",
  Authorization: "Bearer " + token,
});

const data = (response) => response.data;

export const fetchBatches = (token, params) =>
  axios.get(baseUrl + "/batches", { params, headers: headers(token) }).then(data);

export const uploadBatch = (token, payload) =>
  axios.post(baseUrl + "/batches", payload, {
    headers: headers(token, "multipart/form-data"),
  }).then(data);

export const fetchBatchLeads = (token, batchId, params) =>
  axios.get(baseUrl + "/batches/" + batchId + "/leads", {
    params,
    headers: headers(token),
  }).then(data);

export const fetchMyLeads = (token, params) =>
  axios.get(baseUrl + "/my-leads", { params, headers: headers(token) }).then(data);

export const fetchAssignees = (token) =>
  axios.get(baseUrl + "/users", { headers: headers(token) }).then(data);

export const updateAssignments = (token, payload) =>
  axios.patch(baseUrl + "/lead-assignments", payload, {
    headers: headers(token),
  }).then(data);

export const fetchLeadDetails = (token, leadId, taskId) =>
  axios.get(baseUrl + "/lead-profiles/" + leadId, {
    params: taskId ? { task_id: taskId } : undefined,
    headers: headers(token),
  }).then(data);

export const fetchLeadActivities = (token, leadId, params) =>
  axios.get(baseUrl + "/lead-profiles/" + leadId + "/activities", {
    params,
    headers: headers(token),
  }).then(data);

export const fetchLeadAssignmentHistory = (token, leadId) =>
  axios.get(
    process.env.REACT_APP_NOT_SECRET_CODE +
      "/leads/" +
      leadId +
      "/assignment-history",
    { headers: headers(token) },
  ).then(data);

export const fetchRecentLeadOrders = (token, taskId) =>
  axios.get(baseUrl + "/tasks/" + taskId + "/recent-orders", {
    headers: headers(token),
  }).then(data);

export const fetchRecentLeadOrdersByLead = (token, leadId) =>
  axios.get(baseUrl + "/lead-profiles/" + leadId + "/recent-orders", {
    headers: headers(token),
  }).then(data);

export const saveLeadOutcome = (token, taskId, payload) =>
  axios.put(baseUrl + "/tasks/" + taskId + "/outcome", payload, {
    headers: headers(token),
  }).then(data);

export const recordLeadAction = (token, taskId, action) =>
  axios.post(baseUrl + "/tasks/" + taskId + "/actions", { action }, {
    headers: headers(token),
  }).then(data);

export const fetchCallTypes = (token) =>
  axios.get(baseUrl + "/call-types", { headers: headers(token) }).then(data);

export const createCallType = (token, payload) =>
  axios.post(baseUrl + "/call-types", payload, { headers: headers(token) }).then(data);

export const updateCallType = (token, callTypeId, payload) =>
  axios.put(baseUrl + "/call-types/" + callTypeId, payload, { headers: headers(token) }).then(data);

export const fetchLeadOrders = (token, leadId, params) =>
  axios.get(process.env.REACT_APP_NOT_SECRET_CODE + "/orders", {
    params: { ...params, lead_id: leadId },
    headers: headers(token),
  }).then(data);

export const fetchLeadLabOrders = (token, leadId, params) =>
  axios.get(process.env.REACT_APP_NOT_SECRET_CODE + "/laborders", {
    params: { ...params, lead_id: leadId, is_paginate: 1 },
    headers: headers(token),
  }).then(data);

export const fetchLeadConsultations = (token, leadId, params) =>
  axios.get(process.env.REACT_APP_NOT_SECRET_CODE + "/consultations", {
    params: { ...params, patient_id: leadId },
    headers: headers(token),
  }).then(data);

export const fetchLeadCards = (token, leadId) =>
  axios.get(process.env.REACT_APP_NOT_SECRET_CODE + "/leadcards/" + leadId, {
    headers: headers(token),
  }).then(data);

export const fetchLeadFinanceDetails = (token, leadId) =>
  axios.get(process.env.REACT_APP_NOT_SECRET_CODE + "/leads/" + leadId, {
    headers: headers(token),
  }).then(data);

export const fetchLeadFinance = (token, leadId) =>
  axios.get(process.env.REACT_APP_NOT_SECRET_CODE + "/lead-finance/" + leadId, {
    headers: headers(token),
  }).then(data);

export const fetchLeadClaims = (token, leadId, params) =>
  axios.get(process.env.REACT_APP_NOT_SECRET_CODE + "/claim", {
    params: { ...params, lead_id: leadId },
    headers: headers(token),
  }).then(data);

export const fetchLeadClaimTransactions = (token, leadId, params) =>
  axios.get(
    process.env.REACT_APP_NOT_SECRET_CODE + "/lead_trasaction_list/" + leadId,
    { params, headers: headers(token) },
  ).then(data);

export const fetchPackagePolicies = (token, packageId) =>
  axios.get(
    process.env.REACT_APP_NOT_SECRET_CODE + "/package/policy/" + packageId,
    { headers: headers(token) },
  ).then(data);
